// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2jVz3","icon":"SortAdornment_icon__1l_9q","up":"SortAdornment_up__30eyQ","down":"SortAdornment_down___9Y90","active":"SortAdornment_active__3slCG"};